import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CryptoJS from "crypto-js";
import { Link } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import CustomSnackbar from "../shared/snackbar";
import TopBar from "./TopBar";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Razorpay from "../../assets/images/razorpay.png";
import CashFree from "../../assets/images/cashfreePayments.png";
import Phonepe from "../../assets/images/Phonepe.png";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  InputLabel,
  FilledInput,
  InputAdornment,
  FormHelperText,
  Alert,
} from "@mui/material";
import axios from "axios";
import { useEffect } from "react";
import { ClipLoader } from "react-spinners";
import Confirmation from "../CustomerOnboarding/Confirmation";
import Banner from "../../assets/images/banner.svg";
import CouponImage from "../../assets/images/applyCouponCode.svg";
import applyCouponCodeRes from "../../assets/images/applyCouponCodeRes.svg"
import ConnectLoader from '../../assets/images/connectloader.svg';
function Payment() {
  const styles = {
    typography: {},
    // Other styles...
  };
  const MainHeading = {
    typography: {
      fontFamily: "Roboto Flex",
    },
    // Other styles...
  };
  const smallContent = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "18px", // Adjust the font size for smaller screens
        textAlign: "center",
      },
    },
    // Other styles...
  };
  const otherStyles = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "18px", // Adjust the font size for smaller screens
      },
    },
    // Other styles...
  };
  const description = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "16px",
        textAlign: "center",
      },
    },
  };

  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const CREATE_ORDER = `${SERVER_URI}/user/createOrder`;
  const SAVE_TICKET = `${SERVER_URI}/saveTicketAndToken`;
  const PAYMENT = `${SERVER_URI}/user/paymentSuccess`;
  const CREATE_VM = `${SERVER_URI}/user/createVirtualMachine`;
  const PAYMENT_INITIATE = `${SERVER_URI}/paymentintiate`;
  const GET_USER = `${SERVER_URI}/user`;
  const CREATE_COUPON = `${SERVER_URI}/createCoupon`;
  const VALIDATE_COUPON = `${SERVER_URI}/validateCoupon`;
  const LDAP_INTEGRATION = `${SERVER_URI}/Ldap`;
  const MAPPING_VM = `${SERVER_URI}/user/map-vm-to-db`;
  const ADD_VMTOHA = `${SERVER_URI}/user/add-vm-to-ha`;

  const [variant, setMessageVariant] = React.useState("");
  const [snackbaropen, setSnackbarOpen] = React.useState(false);
  const [categories, setCategories] = React.useState([]);
  const [spinner, setSpinner] = React.useState(true);
  const [addressList, setAddressList] = React.useState([]);
  const [message, setMessage] = React.useState("");
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = React.useState(
    "razorpay",
    "Phonepe"
  );
  const [openCashDialog, setOpenCashDialog] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [openexpireDialog, setOpenexpireDialog] = React.useState(false);
  const [open, setAppOpen] = React.useState(false);

  const [paymentUrl, setPaymentUrl] = React.useState("");
  const [merchantId, setMerchantId] = React.useState("");

  const [code, setCode] = useState("");
  const [isCodeValid, setIsCodeValid] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const [isCouponValid, setIsCouponValid] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const [orderplaced, setIsOrderPlaced] = useState(false);
  const [orderButtonText, setOrderButtonText] = useState("Place Order");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  // useEffect(() => {
  //   // Load data only when the component mounts
  //   if (
  //     localStorage.getItem("accessToken") === "" ||
  //     localStorage.getItem("accessToken") === undefined
  //   ) {
  //     setMessage("User not logged in");
  //     setAppOpen(true);
  //     setTimeout(() => {
  //       window.location.href = "/login";
  //       setAppOpen(false);
  //     }, 100);
  //   }
  // });
  const [userId, setUserId] = useState("");

  useEffect(() => {
    // let token = localStorage.getItem("accessToken");
    // if (token) {
    //   let config = {
    //     headers: { Authorization: `Bearer ${token}` },
    //   };
    axios
      .get(GET_USER, {
        withCredentials: true,
      })
      .then((response) => {
        const { paymentDetails } = response.data.user;
        console.log("userId", response.data.user._id);

        setFirstName(response.data.user.name);
        setLastName(response.data.deliveryAddresses.lastname);
        setEmail(response.data.user.email);
        setUserId(response.data.user._id);
        if (
          paymentDetails.paymentStatus === "paid" ||
          paymentDetails.paymentStatus === "SUCCESS" ||
          paymentDetails.responseCode === "SUCCESS"
        ) {
          window.location.href = "/overview"; // Redirect to overview if payment is paid
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  //ORIGINAL CODE

  const createOrder = () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let data = {
      paymentMode: selectedPaymentMode,
    };
    axios
      .post(CREATE_ORDER, data,
        {
          withCredential:true
        }
      )
      .then((response) => {
        setSnackbarOpen(true);
        setIsLoading(true);
        if (response.data) {
          setMessage("Order Created");
          setMessageVariant("success");
          setAddressList(response.data);
          setSpinner(false);

        console.log(response.data);
        const { orderCreate } = response.data;
        console.log(orderCreate);
        const order_id = orderCreate?.id;
        console.log(order_id); // Output: "order_MFxDMogILBXShR"
        const receipt_id = orderCreate.receipt;
        console.log(receipt_id);
        const amount = orderCreate.amount;
        console.log("Amount:", amount);
        // setAmount(amount);
        const currency = orderCreate.currency;
        // Initialize Razorpay options
        let options = {
          // key: '0sx1nNcn0RMSqscNtc22Z5CY',
          // key: "rzp_test_kn0LndhDh40glp",
          key: "rzp_live_lrP0s1CxRNYZnj",
          // amount: amount * 100, // Amount in paise or the smallest currency unit
          currency: currency,
          name: "Razor-Pay",
          description: "For testing purpose",
          order_id: order_id,
          receipt_id: receipt_id,
          handler: function (response) {
            const { razorpay_payment_id, razorpay_signature } = response;
            console.log("Payment ID:", razorpay_payment_id);
            console.log("Signature:", razorpay_signature);

              // Make a POST request to handle payment success with pdf
              axios
                .post(
                  PAYMENT,
                  {
                    razorpay_payment_id: razorpay_payment_id,
                    razorpay_order_id: order_id,
                    razorpay_signature: razorpay_signature,
                    receipt: receipt_id,
                  },
                 {
                  withCredentials:true
                 }
                )
                .then((response) => {
                  console.log("Payment success:", response.data);
                  setIsLoading(true);
                  setMessage(
                    "Payment successful. You will get a mail shortly !!!"
                  );
                  setMessageVariant("success");
                  setSnackbarOpen(true);
                  setTimeout(async () => {
                   
                      await MappingVmToDb();
                      
                  }, 2000);
                  setTimeout(function () {
                    setSnackbarOpen(false);
                    setIsLoading(false);
                    // window.location.href = "/confirmation";
                  }, 2000);
                })
                .catch((error) => {
                  setIsLoading(false);
                  console.error("Error handling payment success:", error);
                  setShowBackdrop(false);
                });
            },
          };
          // Initialize and open Razorpay payment
          var razorpayInstance = new window.Razorpay(options);
          razorpayInstance.open();
        } else if (response.data.warning) {
          setIsLoading(false);
          setMessage(response.data.warning);
          setMessageVariant("warning");
        } else if (response.data.error) {
          setIsLoading(false);
          setMessage(response.data.error);
          setMessageVariant("error");
        }
      })
      .catch((err) => {
        console.log(err);
        setShowBackdrop(false);
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          // Token is expired or invalid, open the dialog
          setOpenexpireDialog(true);
        }
      });
    setTimeout(function () {
      setIsLoading(false);
      setSnackbarOpen(false);
    }, 5000);
  };

  //revert the code after some time
  // const createOrder = async () => {
  //   let token = localStorage.getItem("accessToken");
  //   let config = {
  //     headers: { Authorization: `Bearer ${token}` },
  //   };
  //   let data = {
  //     paymentMode: selectedPaymentMode,
  //   };

  //   try {
  //     const response = await axios.post(CREATE_ORDER, data, config);
  //     setSnackbarOpen(true);
  //     setIsLoading(true);

  //     if (response.data) {
  //       setMessage("Order Created");
  //       setMessageVariant("success");
  //       setAddressList(response.data);
  //       setSpinner(false);

  //       console.log(response.data);
  //       const { orderCreate } = response.data;
  //       console.log(orderCreate);
  //       const order_id = orderCreate?.id;
  //       console.log(order_id); // Output: "order_MFxDMogILBXShR"
  //       const receipt_id = orderCreate.receipt;
  //       console.log(receipt_id);
  //       const amount = orderCreate.amount;
  //       console.log("Amount:", amount);
  // setAmount(amount);
  // const currency = orderCreate.currency;
  // Initialize Razorpay options
  // let options = {
  // key: '0sx1nNcn0RMSqscNtc22Z5CY',
  // key: "rzp_test_kn0LndhDh40glp",
  //key: "rzp_live_pRV1Tx1yDtKWkz",
  // amount: amount * 100, // Amount in paise or the smallest currency unit
  // currency: currency,
  // name: "Razor-Pay",
  // description: "For testing purpose",
  // order_id: order_id,
  // receipt_id: receipt_id,
  // handler: function (response) {
  //   const { razorpay_payment_id, razorpay_signature } = response;
  //   console.log("Payment ID:", razorpay_payment_id);
  //   console.log("Signature:", razorpay_signature);

  // Make a POST request to handle payment success with pdf
  // axios
  //   .post(
  //     PAYMENT,
  //     {
  //       razorpay_payment_id: razorpay_payment_id,
  //       razorpay_order_id: order_id,
  //       razorpay_signature: razorpay_signature,
  //       receipt: receipt_id,
  //     },
  //     config
  // )
  // .then((response) => {
  //   console.log("Payment success:", response.data);
  //   setIsLoading(true);
  //   setMessage(
  //     "Payment successful. You will get a mail shortly !!!"
  //   );
  //   setMessageVariant("success");
  //   setSnackbarOpen(true);
  //   LdapIntegration();
  // Retry logic for create vm API
  //   const retryCount = 2;
  //   let retryAttempt = 0;
  //   const createVm = async () => {
  //     try {
  //         const vmResponse = await axios.get(CREATE_VM, config);
  //         setIsLoading(true);
  //         console.log("Virtual Machine Created:", vmResponse.data);
  //         if (vmResponse.data.message) {
  //             setSnackbarOpen(true);
  //             setMessage(vmResponse.data.message);
  //             setMessageVariant("success");
  //             setAddressList(vmResponse.data);
  //             setTimeout(() => {
  //                 window.location.href = "/confirmation";
  //             }, 2000);
  //             setSpinner(false);
  // handleSecondAPICall();
  //         } else if (vmResponse.data.warning) {
  //             setMessage(vmResponse.data.warning);
  //             setMessageVariant("warning");
  // handleSecondAPICall();
  //         } else if (vmResponse.data.error) {
  //             setSnackbarOpen(true);
  //             setMessage(vmResponse.data.error);
  //             setMessageVariant("error");
  // handleSecondAPICall();
  //         }
  //     } catch (vmError) {
  //         console.error("Error creating virtual machine:", vmError);
  //         setIsLoading(false);
  //         console.error("Error creating virtual machine:", vmError);
  //         setSnackbarOpen(true);
  //         setMessage(vmError.response.data.error);
  //         setMessageVariant("error");
  // handleSecondAPICall();
  //         if (retryAttempt < retryCount - 1) { // Subtracting 1 to ensure only 2 retries
  //             // Increment retryAttempt before retrying
  //             retryAttempt++;
  //             setTimeout(() => {
  //               setSnackbarOpen(false);
  //                 createVm();
  //             }, 3000); // 3-second delay for retries
  //         }
  //     }
  // };

  //   createVm();
  // })
  // .catch((error) => {
  //   setIsLoading(false);
  //   console.error("Error handling payment success:", error);
  //   setShowBackdrop(false);
  // });
  // },
  // };
  // Initialize and open Razorpay payment
  //       var razorpayInstance = new window.Razorpay(options);
  //       razorpayInstance.open();
  //     } else if (response.data.warning) {
  //       setIsLoading(false);
  //       setMessage(response.data.warning);
  //       setMessageVariant("warning");
  //     } else if (response.data.error) {
  //       setIsLoading(false);
  //       setMessage(response.data.error);
  //       setMessageVariant("error");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setShowBackdrop(false);
  //     setIsLoading(false);
  //     if (error.response && error.response.status === 401) {
  //       // Token is expired or invalid, open the dialog
  //       setOpenexpireDialog(true);
  //     }
  //   }

  //   setTimeout(function () {
  //     setIsLoading(false);
  //     setSnackbarOpen(false);
  //   }, 5000);
  // };

  const initiatePayment = async () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let data = {
      paymentMode: selectedPaymentMode,
    };
    try {
      const response = await axios.post(PAYMENT_INITIATE, data, config);
      if (response.data.success === true) {
        // setPaymentUrl(response.data);
        setMessage(response.data.message);
        setMessageVariant("success");
        setSnackbarOpen(true);
        setMerchantId(response.data.data.merchantTransactionId);
        console.log(response.data.data.merchantTransactionId);
        LdapIntegration();
        setTimeout(() => {
          setSnackbarOpen(false);
        }, 2000);
      } else if (response.status === 200) {
      }
      // window.location.href = response.data;
      window.location.href =
        response.data.data.instrumentResponse.redirectInfo.url;
    } catch (error) {
      console.error("Error initiating payment:", error);
      setSnackbarOpen(true);
      setMessage(error);
      setIsLoading(false);
      setMessageVariant("error");
    }
  };
  const checkout = async () => {
    console.log("payment mode :", selectedPaymentMode);
    if (selectedPaymentMode === "razorpay") {
      createOrder();
    } else if (selectedPaymentMode === "Phonepe") {
      await initiatePayment();
      console.log(
        "Payment initiation successful. Proceeding with subsequent API calls..."
      );
    }
  };

  const handlePaymentModeChange = async (event) => {
    setSelectedPaymentMode(event.target.value);
    if (event.target.value === "cash") {
      setOpenCashDialog(true); // Open the Cash dialog when Cash is selected
      // let token = localStorage.getItem("accessToken");
      // let config = {
      //   headers: { Authorization: `Bearer ${token}` },
      // };
      // try {
      //   const response = await axios.get(CREATE_COUPON, config);
      //   setSnackbarOpen(true);
      //   setMessage(response.data.message);
      //   setMessageVariant("success");
      //   setTimeout(() => {
      //     setSnackbarOpen(false);
      //   }, 2000);
      // } catch (error) {
      //   setIsLoading(false);
      //   setMessage("Error generating coupon");
      //   setMessageVariant("error");
      //   console.error("Error generating coupon:", error);
      // }
    } else {
      setOpenCashDialog(false);
    }
  };

  const handleCashDialogClose = () => {
    setOpenCashDialog(false);
    window.location.reload();
  };

  const [selectedAmount, setSelectedAmount] = useState("");

  const handleCashPayment = () => {
    // Implement your logic for Cash payment here
    setOpenCashDialog(false); // Close the Cash dialog after payment
  };

  const handleAmountChange = (event) => {
    setSelectedAmount(event.target.value);
  };
  const [hmacmessage, sethmacMessage] = useState();
  const handleApply = async () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    try {
      const response = await axios.post(
        VALIDATE_COUPON,
        { couponCode: code, amount: selectedAmount },
        {
          withCredentials: true,
        }
      );
      console.log("RESPONSE DATA:", response.data);
      const {
        success,
        message: hmacmessage,
        hmac,
        timestamp,
        nonce,
      } = response.data;

      if (success) {
        // Verify the HMAC
        const isValidHMAC = verifyHMAC(
          hmac,
          hmacmessage,
          timestamp,
          nonce,
          userId
        );
        if (isValidHMAC) {
          // Set success state and proceed with subsequent API calls
          setMessage(message);
          setMessageVariant("success");
          setIsCodeValid(true);
          setIsCouponValid(true);
          sethmacMessage(message);
          // Proceed to call LdapIntegration and MappingVmToDb APIs
          // await LdapIntegration();

          // Wait for 2 seconds before calling MappingVmToDb API
          await delay(2000);

          // Call MappingVmToDb API after the delay
          // await MappingVmToDb();
        } else {
          // Handle HMAC verification failure
          // setMessage("HMAC verification failed");
          // setMessageVariant("error");
          setIsCodeValid(false);
          setIsCouponValid(false);
        }
      } else {
        // Handle unsuccessful response
        setMessage(message);
        setMessageVariant("error");
        setIsCodeValid(false);
        setIsCouponValid(false);
      }

      setSnackbarOpen(true);
      setMessage(response.data.message);
      setMessageVariant("success");
      setTimeout(() => {
        setSnackbarOpen(false);
        setIsApplied(false);
      }, 2000);
      setIsCodeValid(true);
      setIsApplied(true);
      setIsCouponValid(true);
      
    } catch (error) {
      console.log(error.message);
      setSnackbarOpen(true);
      setIsCodeValid(false);
      setIsApplied(true);
      setIsCouponValid(false);
      setMessage("Invalid Coupon Code");
      setMessageVariant("error");
      setTimeout(() => {
        setSnackbarOpen(false);
        setIsApplied(false);
      }, 2000);
    }
  };
  const verifyHMAC = (receivedHMAC, hmacmessage, timestamp, nonce, userId) => {
    console.error(
      "Code, timestamp",
      receivedHMAC,
      hmacmessage,
      timestamp,
      nonce,
      userId
    );
    const message = `${hmacmessage}${userId}${nonce}${timestamp}`;
    const secret = "jhcjzdcbjkdcjkbssckjjdbcj";
    const hash = CryptoJS.HmacSHA256(message, secret).toString(
      CryptoJS.enc.Hex
    );
    console.log("Generated HMAC on frontend:", hash);
    return hash === receivedHMAC;
  };

  const createVM = async () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    setIsLoading(true);
    setIsOrderPlaced(true);
    // Assuming you have access to paymentDetails and its structure includes a paymentStatus field
    if (isCodeValid) {
      let retryCount = 2; // Number of retry attempts
      for (let i = 0; i < retryCount; i++) {
        try {
          const response = await axios.get(CREATE_VM, config);
          console.log("Virtual Machine Created:", response.data.success);
          setIsLoading(true);
          if (response.data.success === true) {
            setSnackbarOpen(true);
            setOrderButtonText("Order Placed");
            setMessage("Successfully Created Virtual Machine!!");
            setMessageVariant("success");
            setAddressList(response.data);
            setTimeout(() => {
              // window.location.href = "/confirmation"; // Redirect after 5 seconds
            }, 6000);
            setSpinner(false);
            handleSecondAPICall();
            return; // Exit the function if successful
          } else if (response.data.warning) {
            console.log("warning:", response.data.warning);
            setMessage(response.data.warning);
            setMessageVariant("warning");
            handleSecondAPICall();
          } else if (response.data.error) {
            setSnackbarOpen(true);
            console.log("Error:", response.data.error);
            setMessage(response.data.error);
            setMessageVariant("error");
            handleSecondAPICall();
          }
          // If there's no success, warning, or error response, retry
        } catch (vmError) {
          console.error("Error creating virtual machine:", vmError);
          if (i === retryCount - 1) {
            // Last attempt failed, show error message
            setOrderButtonText("Order Placed");
            setIsOrderPlaced(true);
            setShowBackdrop(false);
            setIsLoading(false);
            setSnackbarOpen(true);
            handleSecondAPICall();
            setMessage(
              vmError.response
                ? vmError.response.data.error
                : "Failed to create virtual machine."
            );
            setMessageVariant("error");
            setTimeout(() => {
              setSnackbarOpen(false);
            }, 2000);
          } else {
            await new Promise((resolve) => setTimeout(resolve, 3000));
          }
        }
      }
    } else {
      console.error(
        "Payment not yet completed or payment status is not 'paid'."
      );
      // Handle the case where payment is not completed or payment status is not 'paid'
    }
  };
  const LdapIntegration = async () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let data = {
      firstName: firstName,
      lastName: lastName,
      email: email,
    };
    try {
      const response = await axios.post(LDAP_INTEGRATION, data, {
        withCredentials: true,
      });
      console.log("data of ldap", response);
      if (response.status === 200) {
        setMessage(response.data.message);
        setMessageVariant("success");
        setSnackbarOpen(true);
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        await delay(2000);

        await MappingVmToDb();
        setTimeout(async () => {
          setSnackbarOpen(false);
        }, 3000);
      } else {
        // Handle unexpected status codes
        setMessage(response.data.message);
        setMessageVariant("error");
        setSnackbarOpen(true);
        setTimeout(async () => {
          setSnackbarOpen(false);
          window.location.href = "/payment";
        }, 3000);
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
      setMessage(error.message); // Changed from error to error.message for better readability
      setMessageVariant("error");
      setSnackbarOpen(true);
    }
  };

  const MappingVmToDb = async () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const response = await axios.get(MAPPING_VM, {
        withCredentials: true,
      });
      console.log("data of mapping vm", response);
      setMessage(response.data.message);
      console.log("mapping:", response.data.message);
      setMessageVariant("success");
      setSnackbarOpen(true);
      setTimeout(() => {
        setSnackbarOpen(false);
        window.location.href = "/confirmation";
      }, 3000);
    } catch (error) {
      console.error("Error :", error);
      setSnackbarOpen(true);
      setMessage(error);
      setMessageVariant("error");
    }
  };
  const handleSecondAPICall = () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    axios
      .get(ADD_VMTOHA, config)
      .then((response) => {
        // Handle response from the second API call
        console.log("Second API Call Response:", response.data);

        // Show response in snackbar
        setSnackbarOpen(true);
        setMessage(response.data.message); // Assuming the response contains a message
        setMessageVariant("success");
      })
      .catch((error) => {
        // Handle error from the second API call
        console.error("Error making second API call:", error);

        // Show error in snackbar
        setSnackbarOpen(true);
        setMessage("Error: " + error.message); // Set error message in snackbar
        setMessageVariant("error");
      });
  };

  const handlePlaceOrder = async () => {
    await MappingVmToDb();
    // setTimeout(() => {
    //   window.location.href = "/confirmation";
    // }, 2000);
  };
  return (
    <div>
      <TopBar />
      <Box sx={{ padding: "50px", backgroundColor: "#fff",'@media (max-width: 600px)': {padding:'10px'} }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Breadcrumb />
        </div>
        <div style={{ marginTop: "10px" }}>
          <IconButton
            onClick={() => window.history.back()}
            sx={{
              color: "#1E53E8",
              backgroundColor: "#fff",
              borderRadius: "50%",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              "&:hover": {
                backgroundColor: "#f0f0f0", // Optional: a slightly different color on hover
                boxShadow: "0 6px 12px rgba(0, 0, 0, 0.3)",
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </div>
        <Grid container spacing={2} sx={{ marginTop: "10px" ,'@media (max-width: 791px)': {display:'flex',flexDirection: "column-reverse"}}}>
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                padding: "20px",
                backgroundColor: "#F1F1F1",
                borderRadius: "10px",
                '@media (max-width: 600px)': {padding:'10px'}
              }}
            >
              <Typography
                sx={{
                  ...MainHeading.typography,
                  fontSize: "24px",
                  fontWeight: 600,
                  lineHeight: "18px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  color: "#1E53E8",
                }}
              >
                Payment Gateway
              </Typography>
              <Typography
                sx={{
                  ...MainHeading.typography,
                  fontSize: 16,
                  fontWeight: 300,
                  lineHeight: "18px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  color: "#131313",
                  marginTop: "10px",
                }}
              >
                Our secure payment gateway ensures a smooth and hassle-free
                transaction.
              </Typography>

              <Box
                sx={{
                  padding: "20px",
                  backgroundColor: "#fff",
                  margin: "10px",
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "18px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  Choose your Payment Option
                </Typography>
                <FormControl sx={{ display: "flex" }}>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="razorpay"
                    name="radio-buttons-group"
                    onChange={(e) => {
                      handlePaymentModeChange(e);
                      // updateButtonState();
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBlock: "30px",
                      }}
                    >
                      <img src={Razorpay} alt="" />
                      <div>
                        <FormControlLabel
                          value="razorpay"
                          control={<Radio />}
                          // disabled
                          // label="Razorpay"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBlock: "30px",
                      }}
                    >
                      <img src={CashFree} alt="" />
                      <FormControlLabel
                        value="cashfree"
                        control={<Radio />}
                        disabled
                        // label="Cashfree"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBlock: "30px",
                      }}
                    >
                      <img src={Phonepe} alt="" />
                      <FormControlLabel
                        value="Phonepe"
                        control={<Radio />}
                        disabled
                        // label="Wallet"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBlock: "30px",
                        "@media (max-width: 600px)": {
                          width:"50px",
                        },
                      }}
                    >
                       {window.innerWidth <= 600 ? (
    <img src={applyCouponCodeRes} alt="" />
  ) : (
    <img src={CouponImage} alt="" />
  )}
                      <FormControlLabel
                        value="cash"
                        control={<Radio />}
                        // label="Wallet"
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
            <Box sx={{display:'none','@media (max-width: 791px)': {display:'block'}}}>
            <Button
              onClick={checkout}
              disabled={
                selectedPaymentMode !== "razorpay" &&
                selectedPaymentMode !== "Phonepe"
              }
              sx={{
                fontFamily: "Roboto Flex",
                width: "100%",
                textAlign: "center",
                marginTop: "30px",
                backgroundColor: "#C7F760",
                color: "#1E53E8",
                textTransform: "none",
                ontWeight: 900,
                "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
              }}
              variant="contained"
            >
              Proceed
            </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: "#F1F1F1",
                padding: "20px",
                borderRadius: "10px",
              }}
            >
              <img src={Banner} alt="" />
              <br />
              <br />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItem: "center",
                  marginBlock: "10px",
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  <li>Essential's Plan </li>
                  <span
                    style={{
                      ...MainHeading.typography,
                      fontSize: "12px",
                      fontWeight: 300,
                      lineHeight: "18px",
                      letterSpacing: "0em",
                      marginLeft:"22px",
                      color: "#828282",
                    }}
                  >
                    Per Month 799 X 12
                  </span>
                </Typography>
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  ₹9588
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItem: "center",
                  marginBlock: "10px",
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  <li>Device Deposit</li>
                  <span
                    style={{
                      ...MainHeading.typography,
                      fontSize: "12px",
                      fontWeight: 300,
                      lineHeight: "18px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      color: "#828282",
                      marginLeft:"22px",
                    }}
                  >
                    (Refundable)
                  </span>
                </Typography>
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  ₹5000
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItem: "center",
                  marginBlock: "10px",
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  <li>GST 18%</li>
                </Typography>
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  ₹1725
                </Typography>
              </div>
              <Divider />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItem: "center",
                  marginBlock: "10px",
                }}
              >
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                  }}
                >
                  Grand Total
                </Typography>
                <Typography
                  sx={{
                    ...MainHeading.typography,
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#1E53E8",
                  }}
                >
                  ₹16313
                </Typography>
              </div>
            </Box>
            <Box sx={{display:'block','@media (max-width: 791px)': {display:'none'}}}>
            <Button
              onClick={checkout}
              disabled={
                selectedPaymentMode !== "razorpay" &&
                selectedPaymentMode !== "Phonepe"
              }
              sx={{
                fontFamily: "Roboto Flex",
                width: "100%",
                height:"58px",
                textAlign: "center",
                marginTop: "30px",
                backgroundColor: "#C7F760",
                color: "#1E53E8",
                textTransform: "none",
                ontWeight: 900,
                "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
              }}
              variant="contained"
            >
              Proceed
            </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Dialog
        open={openCashDialog}
        onClose={handleCashDialogClose}
        maxWidth="md"
        disableBackdropClick
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            e.stopPropagation();
          }
        }}
      >
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleCashDialogClose} // Call the function to close the modal
          aria-label="close"
          style={{ position: "absolute", top: 0, bottom: 394, right: 20 }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ padding: "30px" }}>
          <DialogTitle
            sx={{
              color: "#000",
              fontFamily: "Poppins",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
            }}
          >
            Apply Coupon Code
          </DialogTitle>
          <DialogContent>
            <FormControl
              variant="filled"
              size="small"
              fullWidth
              sx={{ marginBlock: "20px", width: "400px" }}
            >
              <InputLabel htmlFor="filled-adornment-password">
                Enter Code
              </InputLabel>
              <FilledInput
                id="filled-adornment-password"
                type="text"
                disabled={isApplied}
                value={code}
                onChange={(e) => {
                  console.log("Code changed to:", e.target.value);
                  setCode(e.target.value);
                  setIsApplied(false);
                  setIsCouponValid(false);
                  setIsCodeValid(false);
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <Button
                      sx={{fontFamily: "Roboto Flex",}}
                      variant="text"
                      size="small"
                      color="primary"
                      onClick={handleApply}
                      disabled={isApplied || !selectedAmount} // Disable the button if the code is already applied
                    >
                      {isApplied ? "Applied" : "Apply"}
                    </Button>
                  </InputAdornment>
                }
              />
              <div style={{ marginTop: "10px" }}>
                {isApplied && // Display alert only if the code is applied
                  (isCodeValid ? (
                    <Alert severity="success">Coupon Code Applied!</Alert>
                  ) : (
                    <Alert severity="error">Invalid Coupon Code</Alert>
                  ))}
              </div>
            </FormControl>

            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItem: "center",
                marginBlock: "10px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
              >
                <li>MegaConnect PC</li>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    fontWeight: 300,
                    lineHeight: "18px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#828282",
                  }}
                >
                  (Refundable)
                </span>
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
              >
                ₹3000
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItem: "center",
                marginBlock: "10px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
              >
                <li>Essential's Plan </li>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    fontWeight: 300,
                    lineHeight: "18px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#828282",
                  }}
                >
                  (Charged per Month)
                </span>
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
              >
                ₹3000
              </Typography>
            </div>

            <Divider />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItem: "center",
                marginBlock: "10px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
              >
                Grand Total
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
              >
                ₹6000
              </Typography>
            </div> */}

            <Typography
              sx={{
                fontFamily: "Roboto Flex",
                fontSize: "22px",
                fontWeight: 400,
                lineHeight: "24px",
                letterSpacing: "0em",
                textAlign: "left",
                marginBottom: "10px",
              }}
            >
              Amount -
            </Typography>

            <Box sx={{ display: "flex", gap: 30 }}>
              <FormControlLabel
                value="0"
                control={<Radio />}
                label={<Typography sx={{ fontWeight: "bold" }}>₹0</Typography>}
                checked={selectedAmount === "0"}
                onChange={handleAmountChange}
              />
              <FormControlLabel
                value="5000"
                control={<Radio />}
                label={
                  <Typography sx={{ fontWeight: "bold" }}>₹5000</Typography>
                }
                checked={selectedAmount === "5000"}
                onChange={handleAmountChange}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{fontFamily: "Roboto Flex", width: "100%", textAlign: "center", marginTop: "30px" }}
              variant="contained"
              disabled={!selectedAmount || !isCouponValid || orderplaced}
              // onClick={createVM}
              // onClick={MappingVmToDb}
              onClick={handlePlaceOrder}
            >
              {orderButtonText}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.5)", // Adjust the opacity as needed
            backdropFilter: "blur(1px)",
            zIndex: 9999, // Ensure the overlay is above other content
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            {/* <ClipLoader color={"#374ad7"} size={50} /> */}
            <img src={ConnectLoader} alt="" style={{color:"#374ad7",fontSize:'50%'}}  />
          </Box>
        </div>
      )}

      <CustomSnackbar message={message} variant={variant} open={snackbaropen} />

      <div style={{ display: "none" }}>
        <Confirmation
          ldapIntegration={LdapIntegration}
          mappingVmToDb={MappingVmToDb}
        />
      </div>
    </div>
  );
}

export default Payment;
